import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { LogOut, CreditCard, User, ChevronDown, Info } from 'lucide-react';
import BuyCreditsModal from './BuyCreditsModal';
import { useState } from 'react';

const Header = () => {
  const { user, logout } = useAuth();
  const [showBuyCredits, setShowBuyCredits] = useState(false);

  return (
    <>
      <div className="border-b" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderColor: 'rgba(255, 255, 255, 0.2)' }}>
        <div className="px-8">
          <div className="flex items-center justify-end h-16">
            {/* Right side only - no logo */}
            <div className="flex items-center space-x-4">
              {/* Credits Badge with Tooltip */}
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setShowBuyCredits(true)}
                      className="font-medium border-2 h-9"
                      style={{ 
                        borderColor: '#84a2ac',
                        color: '#245451',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)'
                      }}
                      data-testid="credits-display-btn"
                    >
                      <CreditCard className="mr-2 h-4 w-4" style={{ color: '#406962' }} />
                      <span style={{ color: '#245451', fontWeight: 600 }}>{user?.credit_balance || 0}</span>
                      <span className="ml-1" style={{ color: '#64748B', fontWeight: 400 }}>Credits</span>
                      <Info className="ml-2 h-3.5 w-3.5" style={{ color: '#84a2ac' }} />
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p style={{ color: '#245451', fontWeight: 600 }}>1 Credit = 1 Medical Summary</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>

              {/* User Dropdown */}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button 
                    variant="ghost" 
                    className="h-9 px-3"
                    style={{ color: '#1A1A1A' }}
                  >
                    <User className="mr-2 h-4 w-4" />
                    <span className="font-medium">{user?.name}</span>
                    <ChevronDown className="ml-2 h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56">
                  <div className="px-2 py-2">
                    <p className="text-sm font-medium" style={{ color: '#1A1A1A' }}>{user?.name}</p>
                    <p className="text-xs" style={{ color: '#64748B' }}>{user?.email}</p>
                    {user?.firm_name && (
                      <p className="text-xs mt-1" style={{ color: '#406962' }}>{user?.firm_name}</p>
                    )}
                  </div>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={() => setShowBuyCredits(true)} style={{ color: '#1A1A1A' }}>
                    <CreditCard className="mr-2 h-4 w-4" />
                    Purchase Credits
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={logout} style={{ color: '#DC2626' }}>
                    <LogOut className="mr-2 h-4 w-4" />
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </div>
      <BuyCreditsModal open={showBuyCredits} onClose={() => setShowBuyCredits(false)} />
    </>
  );
};

export default Header;